import React from "react";
import { Link } from "react-router-dom";

/**
 * The Dan Berry lockup: the name set in Cormorant Garamond, with "Berry"
 * carrying the gold. The stacked variant adds the descriptor beneath.
 */
export default function BrandLockup({
  variant = "horizontal",
  markSize = 34,
  to = "/",
  testId = "brand-link",
}) {
  const stacked = variant === "stacked";
  const fontSize = Math.max(20, Math.round(markSize * (stacked ? 0.62 : 0.58)));

  const inner = (
    <>
      <img
        src="/logo.png"
        alt=""
        aria-hidden="true"
        width={markSize}
        height={markSize}
        style={{
          width: markSize,
          height: markSize,
          objectFit: "contain",
          filter: "drop-shadow(0 0 14px rgba(242,213,137,0.28))",
        }}
      />
      <span className={stacked ? "text-center" : ""}>
        <span className="flex items-baseline gap-2 justify-center">
          <span
            style={{
              fontFamily: "'Cormorant Garamond', serif",
              fontWeight: 600,
              fontSize,
              color: "#F5EFE3",
              lineHeight: 1,
            }}
          >
            Dan
          </span>
          <span
            style={{
              fontFamily: "'Cormorant Garamond', serif",
              fontWeight: 600,
              fontSize,
              color: "#F2D589",
              lineHeight: 1,
            }}
          >
            Berry
          </span>
        </span>
        {stacked && (
          <span
            className="block mt-3 text-[10px] uppercase"
            style={{ letterSpacing: "0.32em", color: "rgba(245,239,227,0.55)" }}
          >
            pianist &middot; improviser &middot; educator
          </span>
        )}
      </span>
    </>
  );

  const className = stacked
    ? "flex flex-col items-center gap-3"
    : "flex items-center gap-3";

  if (!to) {
    return (
      <div className={className} data-testid={testId}>
        {inner}
      </div>
    );
  }

  return (
    <Link to={to} className={className} data-testid={testId}>
      {inner}
    </Link>
  );
}
